<template>
  <el-popover placement="bottom" width="300" trigger="click">
    <el-badge slot="reference" :value="badgeCount" :max="99">
      <el-button type="text" icon="el-icon-message-solid"></el-button>
    </el-badge>
    <strong class="notification-header">Notifications</strong>
    <div class="notification-wrapper">
      <ul id="user-notification" class="infinite-list">
        <!-- <li class="infinite-list-header">
          Notifications
        </li> -->
        <li
          v-for="(notif, index) in notifications"
          :key="index"
          :class="{ 'is-new': notif.status }"
        >
          <!-- <router-link :to="notif.url"> -->
          <a href="#" @click="navigate(notif)">
            <div :class="notif.is_read ? '' : 'notif-unread'">
              <span class="notif-message" v-text="notif.message"></span>
              <span>{{ notif.created_at | dateForHumans }}</span>
            </div>
          </a>
          <!-- </router-link> -->
        </li>
        <!-- <li class="infinite-list-footer">
        <router-link to="/">See all notifications</router-link>
      </li> -->
      </ul>
    </div>
  </el-popover>
</template>
<script>
import Notification from "@/models/NotificationClass";
import socket from "@/socket";
export default {
  data() {
    return {};
  },
  computed: {
    badgeCount() {
      return this.notifications.filter(o => o.is_read == 0).length;
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    notifications() {
      return this.$store.getters["dashboard/notifications"];
    }
  },
  methods: {
    playsound() {
      var audio = new Audio(`/sounds/notif.mp3`);
      audio.play();
    },
    // connect() {
    //   let _this = this;
    //   var io = require("socket.io-client");
    //   var socket = io.connect("http://34.219.126.33:8002", { reconnect: true });
    //   // socket.on("notification", function(data) {
    //   //   console.log(data.count);
    //   //   _this.intCount = data.count;
    //   // });
    //   socket.on(`personal-channel.${this.user.username}`, data => {
    //     console.log(data);
    //   });
    // }
    navigate(notification) {
      if (notification.is_read == 0) {
        this.$store
          .dispatch("dashboard/updateNotification", notification)
          .then(() => {
            window.location = notification.url;
          });
      } else {
        window.location = notification.url;
      }
    }
  },
  mounted() {
    // this.connect();
    this.$store.dispatch("dashboard/getNotifications");
  },
  created() {
    socket.on(`personal-channel.${this.user.id}`, data => {
      this.$store.dispatch("dashboard/addNotification", data);
      this.playsound();
    });

    socket.on(`room-channel.${this.user.user_type}`, data => {
      this.$store.dispatch("dashboard/addNotification", data);
      this.playsound();
    });
  }
};
</script>
<style scoped>
.notif-unread .notif-message {
  color: #409eff !important;
  font-weight: bold;
}
.notification-wrapper {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.notification-header {
  color: #409eff;
  padding-bottom: 5px;
  margin-bottom: 15px;
  display: flex;
  border-bottom: 1px solid #eee;
}
</style>
